import axios from 'axios'//引入axios
import qs from 'qs';

//创建一个axios实例
let getToken=axios.create({
    headers:{
        'content-type': 'application/x-www-form-urlencoded'
    },
    baseURL:'https://api.lanjingshuzi.com/',
    // timeout:5000//请求超时时间
})

//request拦截器，对请求参数做处理
getToken.interceptors.request.use(function (config) {
  //获取token的value
  let token = window.sessionStorage.getItem("langjing-admin-token")
  // if(config.method === 'get'){
  //   //如果是get请求，且params是数组类型如arr=[1,2]，则转换成arr=1&arr=2
  //   config.paramsSerializer = function(params) {
  //       return qs.stringify(params, {arrayFormat: 'repeat'})
  //   }}
  if (token) {
      //将token放到请求头发送给服务器,将tokenkey放在请求头中
      config.headers.Authorization = token;     
      //也可以这种写法
      // config.headers['accessToken'] = Token;
       return config;
  }
  
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

// 将axios接口暴露出去
export default getToken;


// WEBPACK FOOTER //
// ./src/axios/token.js